<template lang="pug">
  .quark-shopping-cashback-area
    quark-shopping-cashback(
      ref="cashbackRef"
      page-id="Welfare"
      scene-name-en="platform_points"
      sub-scene-name-en="pp_order_coin_back"
      :env="mobileEnv"
      scene="rebateBonus"
      auxo-grid-module-key="welfare"
      @emitevent="handleEmit"
    )
</template>

<script>
import '@hb/generate-income-components';
import { Navigator } from '@hb/h5-navigator';
import config from '@/const/config';
import SPM from '../common/spm';

export default {
  name: 'MallReward',
  data() {
    return {
      mobileEnv: config.env === 'dev' ? 'fat' : config.env,
    };
  },
  mounted() {},
  methods: {
    handleRedirect() {
      const url = `https://m.hellobike.com/AppCommercialH5/${this.mobileEnv !== 'pro' ? `${this.mobileEnv}/` : ''}latest/index.html#/myorder?scene=rebateBonus`;
      Navigator.go(url);
    },
    handleEmit(e) {
      if (e.detail.type === 'order') {
        // 跳转到我的订单
        this.handleRedirect();
        // 订单点击埋点
        SPM.clickButton({
          buttonName: 'Welfare_onlineretailers_myorder',
          businessInfo: {},
        });
      }
      if (e.detail.type === 'cashback') {
        this.$emit('bounty');
      }
    },
    // 读取剪贴板
    readClipboard() {
      const { cashbackRef } = this.$refs || {};
      if (cashbackRef && cashbackRef.readClipboard) {
        cashbackRef.readClipboard();
      }
    },
  },
};
</script>

<style lang="less" scoped></style>
